import { Item } from './helper/models/homepage'
import { makeAutoObservable } from 'mobx'
import { Group } from './helper/models/getProducts'

class SingleRestaurantMobx {
  singleRestaurant = {} as Item | Group
  constructor() {
    makeAutoObservable(this)
  }
  assign(item: Item) {
    this.singleRestaurant = item
  }
}
export const singleRestaurantMobX = new SingleRestaurantMobx()
export const placeHolderImage = ''
